import React from "react";
import "./offerDraw.css";

const OfferDraw = props => {
	return (
		<div className="offer-draw">
			<div className={props.offerDrawVisible ? "offer-draw-visible" : "offer-draw-hidden"}>
				<div className="offer-draw-container">
					<h1 className="offer-draw-title">DRAW THE GAME</h1>
					<div className="offer-draw-input-container">
						<input type="button" value="ACCEPT" className="game-over-option" onClick={() => props.handleDrawOffer(true)} />
						<input type="button" value="DECLINE" className="game-over-option" onClick={() => props.handleDrawOffer(false)} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default OfferDraw;
